import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTwitter,
  faFacebook,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <footer className="bg-purple-800 text-white py-10">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
          {/* Address Section */}
          <div>
            <h2 className="text-xl font-bold mb-4 border-b border-purple-300 pb-2">Address</h2>
            <ul className="space-y-2">
              <li className="flex items-start gap-2">
                <span className="text-lg">📍</span>
                <span>Gurugram, INDIA</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-lg">📞</span>
                <a href="tel:+919079177216" className="hover:underline">+91-9079177216</a>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-lg">📧</span>
                <a href="mailto:indiashometuition@gmail.com" className="hover:underline">
                  indiashometuition@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Links Section */}
          <div>
            <h2 className="text-xl font-bold mb-4 border-b border-purple-300 pb-2">Quick Links</h2>
            <ul className="space-y-2">
              {["Home", "About", "Services", "Departments", "Contact"].map((link, index) => (
                <li key={index}>
                  <a href="#" className="hover:text-gray-300 transition">{link}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Subscribe & Social */}
          <div>
            <h2 className="text-xl font-bold mb-4 border-b border-purple-300 pb-2">Subscribe Us!</h2>
            <form className="flex flex-col sm:flex-row gap-2">
              <input
                type="text"
                placeholder="Enter email address"
                className="px-4 py-2 rounded-md text-black w-full"
              />
              <input
                type="submit"
                value="Subscribe"
                className="bg-white text-purple-800 px-4 py-2 rounded-md font-semibold hover:bg-purple-200 transition"
              />
            </form>

            <h2 className="text-xl font-bold mt-6 mb-4 border-b border-purple-300 pb-2">
              Connect With Us
            </h2>
            <ul className="flex gap-4 text-2xl">
              <li>
                <a
                  href="https://x.com/INDsHomeTution?t=WfqMvWO5A9QvnGr7YWd4mQ&s=09"
                  className="hover:text-gray-300 transition"
                >
                  <FontAwesomeIcon icon={faTwitter} />
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/share/h1EejeDqpxZ1iZag/?mibextid=qi2Omg"
                  className="hover:text-gray-300 transition"
                >
                  <FontAwesomeIcon icon={faFacebook} />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/indiashometuition?igsh=MTA5YzB2dmFjbjJvNw=="
                  className="hover:text-gray-300 transition"
                >
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
              </li>
              <li>
                <a
                  href="https://youtube.com/@indiashometuition?si=v_P94wZNl1X6zO0o"
                  className="hover:text-gray-300 transition"
                >
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="text-center text-sm border-t border-purple-500 pt-4">
          &copy; {new Date().getFullYear()} All rights reserved by{" "}
          <a
            href="https://www.instagram.com/indiashometuition?igsh=MTA5YzB2dmFjbjJvNw=="
            className="underline hover:text-gray-300 transition"
            target="_blank"
            rel="noopener noreferrer"
          >
            @IndiasHomeTuition
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
